<template>
  <div>

    <div class="home mb-10 flex flex-col md:w-1/2 md:mx-auto my-4 gap-4 mx-4">
      <p class="text-gray-500 text-center text-xs my-4 font-medium">Search your district or state</p>
      <div class="md:mx-2 relative">
        <svg class="absolute fill-current text-gray-400 z-10 top-1/2 transform -translate-y-1/2 left-4" width="24"
             height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z"
              fill=""/>
        </svg>
        <input type="search"
               class="bg-gray-800 hover:bg-blue-900 focus:bg-blue-900  appearance-none text-base relative focus:ring-2 ring-2 ring-blue-500 ring-offset-blue-500 w-full pl-12 py-2 rounded-lg filter drop-shadow-xl text-gray-400 placeholder-current"
               :value="selctedCityName" @focus="ToggleSuggestion = !ToggleSuggestion"
                @input="evt=>selctedCityName=evt.target.value"
               placeholder="Search your district"/>
      </div>
      <div v-if="ToggleSuggestion"  class="md:px-2">
       <div class="text-gray-400 flex place-items-center text-sm mb-4">
         <p class="text-sm mr-2"> Suggestions </p>
          <span class="text-xs flex place-items-center text-gray-500 relative">
            <span class="h-2 w-2 m-auto animate-ping absolute inline-flex rounded-full bg-blue-400 opacity-75"></span>
            <span class="rounded-full absolute m-auto h-2 w-2 bg-blue-500"></span>
          </span>
        </div>
        <div class="grid grid-cols-2 gap-4 w-full ">
          <a class="text-gray-300 bg-gray-800 text-sm cursor-pointer rounded-md hover:bg-blue-900 hover:text-blue-100 p-2 focus:text-blue-500"
          @click="selectCity(city)" :key="city" v-for="city in filteredCity">{{ city['Name'] }}</a>
        </div>
        </div>
      
      <div class="flex flex-col justify-between md:mx-2 relative">
        <div class="flex justify-between relative text-gray-400">
          <!-- <label for="">Select Resources</label> -->
          <svg class="fill-current text-gray-400 absolute right-4 top-4" width="24" height="26" viewBox="0 0 24 26" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 4.33333V5.41213C4.00157 5.53917 4.0465 5.66034 4.12502 5.74926L10.1929 12.8385C10.2714 12.9275 10.3164 13.0486 10.3179 13.1757V19.8122C10.3178 19.9025 10.3396 19.991 10.3808 20.0676C10.4221 20.1443 10.4812 20.206 10.5513 20.2457L13.8436 21.6038C13.9072 21.6398 13.9777 21.6565 14.0485 21.6523C14.1192 21.6481 14.1878 21.6231 14.2479 21.5797C14.3079 21.5364 14.3574 21.476 14.3917 21.4044C14.426 21.3328 14.4439 21.2522 14.4438 21.1704V13.089C14.4553 12.9588 14.5089 12.8384 14.5938 12.7518L20.5283 5.76852C20.6068 5.6796 20.6518 5.55843 20.6533 5.4314V4.33333H4Z"
                fill=""/>
          </svg>
        
        <select id="resourcetype" v-model="SelectedResourceName" name="resource"
            class="w-full my-2 hover:bg-blue-900 focus:bg-blue-900 ring-2 ring-blue-500 hover:text-white border-none md:mx-auto rounded-lg focus:text-gray-200 text-gray-400 px-4 py-2 bg-gray-800 appearance-none"
            required>
            <option disabled :value="null">Filter by Resources</option>
          <option :key="id" v-for="(resource , id) in currentResource" :value="resource['resourceName'] ">
            {{ resource['resourceName'] }}
          </option>
        </select>
        </div>
      </div>

    </div>
    <div class="px-4" :key="result.id" v-for="result in allPosts">
      <div
          v-if="result['city']['Name'] === selctedCityName &&  result['resource']['resourceName'] === SelectedResourceName || result['city']['Name'] === selctedCityName && SelectedResourceName === null" >
          <card :name="result['personName']"
              :phone_num="result['personContactNo']"
              :resource="result['resource']['resourceName']"
              :verified="result['approved']"
              :updated="result['updatedAt']"
              :City="result['city']['Name']"
              :Address="result['address']"
              :likes="result['like']"
              :dislikes="result['disLike']"
              :otherinfo="result['otherInfo']"
              :sourcelink="result['links']"/>
      </div>
    </div>
    <div v-if="selctedCityName === null || selctedCityName === '' "
        class="text-gray-300 mt-14">
      <img width="600" height="500" class="w-1/2 md:w-1/4 mx-auto" src="../assets/search.svg" alt="waiting to search">
      <p class="text-center mt-6">Waiting to Search ...
      </p>
    </div>


  </div>
</template>

<style >
* {
  outline: none;
}

</style>

<script>
import Button from '@/components/input.vue'
import card from '@/components/cards.vue'
import Spinner from "@/components/loader.vue"
import {mapState, mapActions, mapGetters} from 'vuex'
import {store} from "@/main"

export default {
  name: 'Home',
  computed: {
    ...mapState(['currentCity', 'currentResource', 'allPosts', 'filteredCity']),
    ...mapGetters(['getCurrentResource'])
  },
  components: {
    Button,
    card,
    Spinner
  },
  data() {
    return {
      data: {}, selctedCityName: null, SelectedResourceName: null,
      cityname: '', disabled: true,ToggleSuggestion : false,
      resource: '',
      key: '',
      ishidden: true,
    }
  },
  watch:{
      selctedCityName : function(){
        this.cityChange()
        this.ToggleSuggestion = true
      }
  },
  async created() {
    await this.fetchCity()
    await this.cityChange()
    await this.fetchPosts()
    await this.fetchResources()
  },
  methods: {
    async selectCity(city) {
      this.selctedCityName = city.Name
      await store.dispatch('setSelectedCity', city)
      this.ToggleSuggestion = !this.ToggleSuggestion
    },
    async cityChange() {
      await store.dispatch("setCityAction", this.selctedCityName)
    },
    ...mapActions(['fetchCity', 'fetchResources', 'fetchPosts']),
    showList() {
      this.ishidden = !this.ishidden
    },

  },
}

</script>
